import { useTranslation } from "react-i18next"
import {
  SelectEntity,
  SelectEntityProps,
} from "../../../-components/entity-select"

interface OwnerGroupSingleSelectProps
  extends Omit<
    SelectEntityProps<"/api/OwnerGroup/GetSimpleOwnerGroupsByPermissionArea">,
    "url" | "toRequest" | "getLabel" | "getId"
  > {}

export function OwnerGroupSingleSelectForReminders({
  value,
  onChange,
  required,
  disabled,
  placeholder,
}: OwnerGroupSingleSelectProps) {
  const { t } = useTranslation("app_server")
  return (
    <SelectEntity
      label={t("Owner")}
      url="/api/OwnerGroup/GetSimpleOwnerGroupsByPermissionArea"
      toRequest={() => ({
        permissionArea: "Reminders",
        onlyWithWritePermission: true,
      })}
      getLabel={(v) => v.name}
      getId={(v) => v.ownerGroupId}
      value={value}
      onChange={onChange}
      required={required}
      disabled={disabled}
      placeholder={placeholder ?? t("SearchOwnerGroup")}
      clearable
    />
  )
}
